export default "__VITE_ASSET__zNR4Nk_r__"